import { render } from "./aboutPrints.vue?vue&type=template&id=cdc293d8"
import script from "./aboutPrints.vue?vue&type=script&lang=js"
export * from "./aboutPrints.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__